import axios from '@/libs/api.request'

/**
 * 获取云知印自助文印印量总数
 * @returns {Promise} 返回包含totalPages、todayPages等数据的Promise
 */
export const getPrintVolumeTotal = () => {
  return axios.request({
    url: '/print/dashboard/GetPrintVolumeTotal',
    method: 'get'
  })
}

/**
 * 获取首页统计数据
 * @returns {Promise} 返回包含todayOrderCount、machineCount、userCount等数据的Promise
 */
export const getHomeCounts = () => {
  return axios.request({
    url: '/print/dashboard/GetHomeCounts',
    method: 'get'
  })
}

/**
 * 获取全国设备分布统计数据
 * @returns {Promise} 返回包含provinceStats、summary等数据的Promise
 */
export const getProvinceDeviceStats = () => {
  return axios.request({
    url: '/print/dashboard/GetProvinceDeviceStats',
    method: 'get'
  })
}

/**
 * 获取印量与收益走势数据
 * @returns {Promise} 返回包含trend、summary等数据的Promise
 */
export const getPrintRevenueTrend = () => {
  return axios.request({
    url: '/print/dashboard/GetPrintRevenueTrend',
    method: 'get'
  })
}

/**
 * 获取部署行业分布统计数据
 * @returns {Promise} 返回包含sceneStats、summary等数据的Promise
 */
export const getSceneDeviceStats = () => {
  return axios.request({
    url: '/print/dashboard/GetSceneDeviceStats',
    method: 'get'
  })
}

/**
 * 获取设备运行状态统计数据
 * @returns {Promise} 返回包含normal、offLine、error、expire等数据的Promise
 */
export const getMachineReport = () => {
  return axios.request({
    url: '/print/dashboard/GetMachineReport',
    method: 'get'
  })
}

/**
 * 获取设备类型分布统计数据
 * @returns {Promise} 返回包含设备类型分布数据的Promise
 */
export const getDeviceTypeStats = () => {
  return axios.request({
    url: '/print/dashboard/GetDeviceTypeStats',
    method: 'get'
  })
}

/**
 * 获取订单量走势数据
 * @returns {Promise} 返回包含trend、summary等数据的Promise
 */
export const getOrderTrend = () => {
  return axios.request({
    url: '/print/dashboard/GetOrderTrend',
    method: 'get'
  })
}

/**
 * 获取当前位置信息（基于IP定位）
 * @returns {Promise} 返回包含IP、经纬度、地址等定位数据的Promise
 */
export const getCurrentLocation = () => {
  return axios.request({
    url: '/print/dashboard/GetLocationByIP',
    method: 'get'
  })
}
